import { __assign } from '../../../_virtual/_tslib.js';
import * as React from 'react';
import { IconWrapper } from '../../../components/icon-wrapper.js';

var SvgFeatherOrigami = React.forwardRef(function SvgFeatherOrigami(props, ref) {
    return (React.createElement(IconWrapper, __assign({ ref: ref }, props), React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { d: "M12 12V4a1 1 0 0 1 1-1h6.297a1 1 0 0 1 .651 1.759l-4.696 4.025" }),
        React.createElement("path", { d: "m12 21-7.414-7.414A2 2 0 0 1 4 12.172V6.415a1.002 1.002 0 0 1 1.707-.707L20 20.009" }),
        React.createElement("path", { d: "m12.214 3.381 8.414 14.966a1 1 0 0 1-.167 1.199l-1.168 1.163a1 1 0 0 1-.706.291H6.351a1 1 0 0 1-.625-.219L3.25 18.8a1 1 0 0 1 .631-1.781l4.165.027" }))));
});

export { SvgFeatherOrigami as default };
